import { studioThemeCustomize } from '@App/Studio/app-config/theme'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react'

const ThemModeContext = createContext({
	handleToggleMode: () => {}
})

export const useQuizThemeContext = () => useContext(ThemModeContext)

const MUIThemeQuizProvider = props => {
	// Initialize theme with system preference detection
	const [modeTheme, setModeTheme] = useState(() => {
		// Check localStorage first
		const saved = localStorage.getItem('quiz_theme')
		if (saved) return saved

		// If no saved preference, detect system preference
		const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
		return prefersDark ? 'dark' : 'light'
	})

	const handleMode = useCallback(() => {
		setModeTheme(prev => (prev === 'light' ? 'dark' : 'light'))
	}, [])

	// Save theme preference to localStorage
	useEffect(() => {
		localStorage.setItem('quiz_theme', modeTheme)
	}, [modeTheme])

	const theme = useMemo(() => createTheme(studioThemeCustomize(modeTheme)), [modeTheme])

	const context = {
		handleToggleMode: handleMode,
		modeTheme
	}

	return (
		<ThemModeContext.Provider value={context}>
			<ThemeProvider theme={theme}>
				<CssBaseline />
				{props.children}
			</ThemeProvider>
		</ThemModeContext.Provider>
	)
}

export default MUIThemeQuizProvider
